/**
 * Filter for separate card numbers in groups
 */
(function (itxApp) {

    'use strict';

    angular.module('itxApp.common').filter('cardNumber', ItxCardNumberFlt);

    function ItxCardNumberFlt() {
        return function (cardNumber) {
            return _.reduce(_.chunk(cardNumber, 4), function (result, value) {
                result = result + value.join('') + ' ';
                return result;
            }, '');
        };
    }

    /** Public */
    itxApp.common.ItxCardNumberFlt = ItxCardNumberFlt;

})(window.itxApp);
